export default __webpack_public_path__ + "static/media/WeddingService.dc742d2f.webp";